import {request} from '@/api';
import {FeedFile} from '@/api/models/FeedFiles.ts';
import {Create, Entity, Stub} from '@/api/models/index.ts';
import {toNamesObject} from '@/util/enum.ts';

export interface Provider extends Entity {
	username: string,
	createdDate: Date,
	state: ProviderState,
	files: Array<Stub<FeedFile, 'name' | 'path' | 'lastModified' | 'inactive' | 'feed'>>
}

export enum ProviderState {
	Creating = 'creating',
	Updating = 'updating',
	Deleting = 'deleting',
	Ok = 'ok',
	Failed = 'failed',
}

export const PROVIDER_STATE_NAMES = toNamesObject(ProviderState);

export function isPendingState(state: ProviderState): boolean {
	return state !== ProviderState.Ok && state !== ProviderState.Failed;
}

export type ProviderCreate = Create<Provider, 'username', 'createdDate' | 'state'>;

export interface PasswordResponse {
	password: string,
}

export namespace Providers {
	export async function list(): Promise<Provider[]> {
		const providers: Provider[] = await request('/providers');
		return providers.map(denormalize);
	}

	export function create(data: ProviderCreate): Promise<PasswordResponse> {
		return request('/providers', {
			method: 'PUT',
			body: JSON.stringify(data),
		});
	}

	export function resetPassword(id: number): Promise<PasswordResponse> {
		return request(`/providers/${id}/reset-password`, {
			method: 'POST',
		});
	}

	export function remove(id: number): Promise<void> {
		return request(`/providers/${id}`, {
			method: 'DELETE',
		});
	}

	function denormalize(provider: Provider): Provider {
		provider.createdDate = new Date(provider.createdDate);
		return provider;
	}
}
